import { render } from "./ProductUpgradeIcon.vue?vue&type=template&id=039de914"
import script from "./ProductUpgradeIcon.vue?vue&type=script&lang=js"
export * from "./ProductUpgradeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ProductUpgradeIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "039de914"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('039de914', __exports__)) {
    api.reload('039de914', __exports__)
  }
  
  module.hot.accept("./ProductUpgradeIcon.vue?vue&type=template&id=039de914", () => {
    api.rerender('039de914', render)
  })

}


export default __exports__